<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX833、CX961、CX962、CX963、XC8355、XC9635、XC9645、XC9655 多功能一体机">
     CX833、CX961、CX962、CX963、XC8355、XC9635、XC9645、XC9655 多功能一体机
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sc" title="安全信息">
     安全信息
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="约定">
      约定
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e43" title="产品声明">
      产品声明
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_sc" title="了解打印机">
     了解打印机
    </a>
   </p>
   <div id="divd0e221">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sc" title="查找有关打印机的信息">
      查找有关打印机的信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_sc" title="查找打印机序列号">
      查找打印机序列号
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_sc" title="打印机配置">
      打印机配置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sc" title="使用控制面板">
      使用控制面板
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_sc" title="主屏幕图标">
      主屏幕图标
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_sc" title="指示灯颜色">
      指示灯颜色
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_sc" title="使用自动文档传送器和扫描仪玻璃">
      使用自动文档传送器和扫描仪玻璃
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_sc" title="定位安全槽">
      定位安全槽
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e769" title="选择纸张">
      选择纸张
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10634" title="其他打印机功能和支持">
      其他打印机功能和支持
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sc" title="设置、安装和配置">
     设置、安装和配置
    </a>
   </p>
   <div id="divd0e10761">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_sc" title="为打印机选择位置">
      为打印机选择位置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_sc" title="打印机端口">
      打印机端口
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-center-topic.html#d0e10960" title="配置应用程序和解决方案">
      配置应用程序和解决方案
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e11137" title="设置和使用辅助功能">
      设置和使用辅助功能
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e11442" title="设置打印机发送传真">
      设置打印机发送传真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_sc" title="加载纸张和特殊介质">
      加载纸张和特殊介质
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e12238" title="安装和更新软件、驱动程序和固件">
      安装和更新软件、驱动程序和固件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e12564" title="安装硬件选件">
      安装硬件选件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e14095" title="网络连接">
      网络连接
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_sc" title="保护打印机">
     保护打印机
    </a>
   </p>
   <div id="divd0e14447">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sc" title="清除打印机内存">
      清除打印机内存
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_sc" title="清除打印机存储驱动器">
      清除打印机存储驱动器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sc" title="还原出厂默认设置">
      还原出厂默认设置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_sc" title="易失性声明">
      易失性声明
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_sc" title="打印">
     打印
    </a>
   </p>
   <div id="divd0e14639">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_sc" title="从计算机打印">
      从计算机打印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14690" title="从移动设备打印">
      从移动设备打印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_sc" title="从闪存驱动器打印">
      从闪存驱动器打印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sc" title="配置保密作业">
      配置保密作业
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sc" title="打印保密作业和其他挂起作业">
      打印保密作业和其他挂起作业
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_sc" title="打印字体样本列表">
      打印字体样本列表
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_sc" title="打印目录列表">
      打印目录列表
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_sc" title="将分隔页置于打印作业中">
      将分隔页置于打印作业中
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sc" title="取消打印作业">
      取消打印作业
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_sc" title="调整碳粉浓度">
      调整碳粉浓度
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_sc" title="复印">
     复印
    </a>
   </p>
   <div id="divd0e15185">
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_sc" title="制作副本">
      制作副本
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_sc" title="复印照片">
      复印照片
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-letterhead-topic.html#copying-on-letterhead_sc" title="使用信签复印">
      使用信签复印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_sc" title="在纸张的两个面上复印">
      在纸张的两个面上复印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_sc" title="缩小或放大副本">
      缩小或放大副本
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_sc" title="逐份打印副本">
      逐份打印副本
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_sc" title="在副本之间放置分隔页">
      在副本之间放置分隔页
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_sc" title="将多个页面复印到一张纸上">
      将多个页面复印到一张纸上
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_sc" title="复印卡">
      复印卡
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_sc" title="创建复印快捷方式">
      创建复印快捷方式
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_sc" title="电子邮件">
     电子邮件
    </a>
   </p>
   <div id="divd0e15458">
    <p class="toc-2-style">
     <a href="configuring-smtp-settings-topic.html#configuring-smtp-settings_sc" title="配置 SMTP 码设置。">
      配置 SMTP 码设置。
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_sc" title="发送电子邮件">
      发送电子邮件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_sc" title="创建电子邮件快捷方式">
      创建电子邮件快捷方式
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_sc" title="传真">
     传真
    </a>
   </p>
   <div id="divd0e16907">
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_sc" title="发送传真">
      发送传真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_sc" title="调度传真">
      调度传真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_sc" title="创建传真目标快捷方式">
      创建传真目标快捷方式
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_sc" title="更改传真分辨率">
      更改传真分辨率
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_sc" title="调整传真浓度">
      调整传真浓度
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_sc" title="打印传真日志">
      打印传真日志
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_sc" title="阻止垃圾传真">
      阻止垃圾传真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_sc" title="挂起传真">
      挂起传真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_sc" title="转发传真">
      转发传真
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_sc" title="扫描">
     扫描
    </a>
   </p>
   <div id="divd0e17203">
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_sc" title="扫描到计算机">
      扫描到计算机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_sc" title="扫描到 FTP 服务器">
      扫描到 FTP 服务器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_sc" title="创建 FTP 快捷方式">
      创建 FTP 快捷方式
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-network-folder-topic.html#scanning-to-network-folder_sc" title="扫描到网络文件夹">
      扫描到网络文件夹
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-network-folder-destination-topic.html#configuring-network-folder-destination_sc" title="配置网络文件夹目标">
      配置网络文件夹目标
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_sc" title="创建网络文件夹快捷方式">
      创建网络文件夹快捷方式
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_sc" title="扫描到闪存驱动器">
      扫描到闪存驱动器
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_sc" title="打印机菜单">
     打印机菜单
    </a>
   </p>
   <div id="divd0e17492">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_sc" title="菜单一览表">
      菜单一览表
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e17806" title="设备">
      设备
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e20040" title="打印">
      打印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e21322" title="纸张">
      纸张
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e21654" title="复印">
      复印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e22213" title="传真">
      传真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e24080" title="电子邮件">
      电子邮件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e25177" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e25883" title="USB 驱动器">
      USB 驱动器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e26729" title="网络/端口">
      网络/端口
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e28880" title="安全">
      安全
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e29977" title="云服务">
      云服务
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e30034" title="报告">
      报告
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_sc" title="故障排除">
      <strong>
       故障排除
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_sc" title="Forms Merge">
      <strong>
       Forms Merge
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_sc" title="打印菜单设置页">
      打印
      <strong>
       菜单设置页
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_sc" title="打印机装订器选项">
     打印机装订器选项
    </a>
   </p>
   <div id="divd0e30517">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_sc" title="使用装订器">
      使用装订器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_sc" title="使用打孔装订器">
      使用打孔装订器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_sc" title="使用偏移接纸架">
      使用偏移接纸架
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_sc" title="使用小册子装订器">
      使用小册子装订器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_sc" title="使用配有折叠选件的输纸器">
      使用配有折叠选件的输纸器
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sc" title="维护打印机">
     维护打印机
    </a>
   </p>
   <div id="divd0e30927">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_sc" title="检查部件和耗材的状态">
      检查部件和耗材的状态
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_sc" title="配置耗材通知">
      配置耗材通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_sc" title="设置电子邮件警报">
      设置电子邮件警报
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_sc" title="生成报告和日志">
      生成报告和日志
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_sc" title="订购部件和耗材">
      订购部件和耗材
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e31782" title="更换部件和耗材">
      更换部件和耗材
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e32406" title="清洁打印机部件">
      清洁打印机部件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e32570" title="节省能源和纸张">
      节省能源和纸张
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_sc" title="将打印机移动到其他位置">
      将打印机移动到其他位置
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_sc" title="解决问题">
     解决问题
    </a>
   </p>
   <div id="divd0e32708">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_sc" title="打印质量问题">
      打印质量问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_sc" title="打印机错误代码">
      打印机错误代码
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_sc" title="打印问题">
      打印问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_sc" title="打印机不响应">
      打印机不响应
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_sc" title="无法读取闪存驱动器">
      无法读取闪存驱动器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_sc" title="启用 USB 端口">
      启用 USB 端口
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_sc" title="清除卡纸">
      清除卡纸
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e36132" title="网络连接问题">
      网络连接问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e36225" title="硬件选件问题">
      硬件选件问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e36398" title="耗材问题">
      耗材问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e36546" title="进纸问题">
      进纸问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e36740" title="电子邮件问题">
      电子邮件问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e36795" title="传真问题">
      传真问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e37117" title="扫描问题">
      扫描问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e37535" title="颜色质量问题">
      颜色质量问题
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sc" title="联系客户支持">
      联系客户支持
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_sc" title="回收和处理">
     回收和处理
    </a>
   </p>
   <div id="divd0e37761">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_sc" title="回收 Lexmark 产品">
      回收 Lexmark 产品
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_sc" title="回收 Lexmark 包装材料">
      回收 Lexmark 包装材料
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sc" title="注意事项">
     注意事项
    </a>
   </p>
   <div id="divd0e37797">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37800" title="产品信息">
      产品信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37817" title="版本注意事项">
      版本注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sc" title="商标">
      商标
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sc" title="许可注意事项">
      许可注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sc" title="噪音水平">
      噪音水平
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37915" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sc" title="产品处理">
      产品处理
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37949" title="中国 RoHS 计划的信息">
      中国 RoHS 计划的信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sc" title="静电敏感注意事项">
      静电敏感注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sc" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sc" title="温度信息">
      温度信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sc" title="激光注意事项">
      激光注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sc" title="功耗">
      功耗
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38335" title="无线产品的监管注意事项">
      无线产品的监管注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_sc" title="模块化组件注意事项">
      模块化组件注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_sc" title="无线频率辐射暴露通告">
      无线频率辐射暴露通告
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38360" title="CCC EMC 注意事项">
      CCC EMC  注意事项
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_sc" title="无线电干扰注意事项">
      无线电干扰注意事项
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue